module.exports = __webpack_public_path__ + "img/80004.9fe2384b.png";